<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row class="flex-nowrap">
                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Profissional"
                        v-model="form.profissional.nome"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Data de nascimento"
                        v-model="form.profissional.dataNascimento"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="CPF"
                        disabled
                        v-model="form.profissional.cpf"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-area
                type="section"
                title="Inclusão de nova jornada"
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.unidadesParametrizadas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="jornada.unidadeId"
                            :disabled="jornada.unidadeDisabled ? true : false"
                            value-field="unidadeId"
                            :validations="validations.unidadeId"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="infraestruturas"
                            textField="nome"
                            v-model="jornada.infraestruturaId"
                            valueField="id"
                            show-default-option
                            :validations="validations.infraestruturaId"
                            :disabled="!jornada.unidadeId"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="prestadores"
                            label="Prestador"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="jornada.prestadorId"
                            value-field="prestadorId"
                            :validations="validations.prestadorId"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="grupoExames"
                            label="Grupo de exame"
                            show-default-option
                            text-field="nome"
                            v-model="jornada.exameId"
                            value-field="id"
                            :validations="validations.exameId"
                            :disabled="!jornada.unidadeId && !jornada.infraestruturaId"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-row class="flex-nowrap">
                            <rkm-col cols="6">
                                <rkm-row>
                                    <rkm-col cols="4">
                                        <rkm-form-select
                                            ref="tipoId"
                                            :options="form.tipos"
                                            label="Tipo de Jornada"
                                            show-default-option
                                            text-field="nome"
                                            v-model="jornada.tipoId"
                                            :disabled="this.index == null ? false : true"
                                            value-field="id"
                                            :readonly="isReadOnly"
                                            :validations="validations.tipoId"
                                            @change="resetJornada"
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-date-picker
                                            ref="periodo"
                                            range
                                            :range-inline="false"
                                            start-label="Período de"
                                            end-label="Até"
                                            v-model="jornada.periodo"
                                            :disabled="this.index == null ? false : true"
                                            :start-validations="validations.periodo.start"
                                            :end-validations="validations.periodo.end"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="12">
                                        <rkm-form-checkbox-group
                                            label="Dias da semana"
                                            v-model="jornada.diasSemana"
                                            :options="form.diasSemana"
                                            text-field="nome"
                                            value-field="id"
                                            buttons
                                            button-color="outline-primary"
                                            :validations="validations.diasSemana"
                                            small
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="6">
                                        <rkm-form-time-picker
                                            label="Horário Inicial"
                                            ref="horaInicial"
                                            v-model="jornada.horaInicial"
                                            :disabled="!jornada.infraestruturaId || !jornada.tipoId"
                                            :validations="validations.horaInicial"
                                            @input="handleBlurHoraFim"
                                            @change="handleBlurHoraFim"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="6">
                                        <rkm-form-time-picker
                                            label="Horário Final"
                                            ref="horaFim"
                                            v-model="jornada.horaFim"
                                            :validations="validations.horaFim"
                                            :disabled="!jornada.horaInicial"
                                            @input="handleBlurHoraFim"
                                            @change="handleBlurHoraFim"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="6">
                                        <rkm-form-select
                                            ref="statusId"
                                            :options="form.status"
                                            label="Status"
                                            text-field="nome"
                                            v-model="jornada.statusId"
                                            value-field="id"
                                            :disabled="!jornada.infraestruturaId || !jornada.tipoId"
                                            :validations="validations.statusId"
                                        />
                                    </rkm-col>

                                    <rkm-col
                                        cols="6"
                                    >
                                        <rkm-form-input
                                            ref="vagas"
                                            label="Número de vagas"
                                            number
                                            v-model="jornada.vagas"
                                            @change="handleBlur"
                                            :validations="validations.vagas"
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1" v-if="form.habilitaAgendamentoApp">
                                        <rkm-form-input
                                            ref="vagasApp"
                                            label="Vagas APP Cidadão"
                                            tooltip-top="Informe aqui a quantidade de vagas reservadas ao APP Cidadão. Essas vagas serão somadas às vagas normais para cálculo automático do tempo de atendimento."
                                            number
                                            v-model="jornada.vagasApp"
                                            @change="handleBlur"
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-input
                                            ref="tempoAtendimento"
                                            label="Tempo de atendimento"
                                            v-model="jornada.tempoAtendimento"
                                            :validations="validations.tempoAtendimento"
                                            @change="handleBlurTempoAtendimento"
                                        >
                                            <rkm-input-group-append slot="append">
                                                <rkm-input-group-text>
                                                    em minutos.
                                                </rkm-input-group-text>
                                            </rkm-input-group-append>
                                        </rkm-form-input>
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row class="mt-0 justify-content-end">
                                    <rkm-col class="flex-grow-1 d-flex justify-content-end mt-0">
                                        <rkm-button
                                            v-if="jornada.jornadaId == null"
                                            @click="cancelForm"
                                            color="secondary"
                                        >
                                            Limpar
                                        </rkm-button>

                                        <rkm-button
                                            v-if="jornada.jornadaId !== null"
                                            @click="cancelForm"
                                            color="secondary"
                                            :disabled="desabilitaVolta ? true : false"
                                        >
                                            Voltar
                                        </rkm-button>

                                        <rkm-button
                                            @click.stop="add"
                                            color="primary"
                                        >
                                            {{ jornada.jornadaId !== null ? 'Alterar Jornada' : 'Incluir jornada' }}
                                        </rkm-button>
                                    </rkm-col>
                                </rkm-row>

                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-calendar
                                    :items="diasCalendario"
                                    @click="modalCalendario"
                                />

                                <rkm-row class="flex-grow-1 ml-2">
                                    <rkm-icon
                                        icon="exclamation-circle"
                                        class="leg-verde d-flex float-left"
                                        small
                                    />
                                    <rkm-col class="mt-1 pt-0">
                                        vagas disponíveis
                                    </rkm-col>

                                    <rkm-icon
                                        icon="exclamation-circle"
                                        class="leg-azul d-flex float-left"
                                        small
                                    />
                                    <rkm-col class="mt-1 pt-0">
                                        data selecionada
                                    </rkm-col>

                                    <rkm-icon
                                        icon="exclamation-circle"
                                        class="leg-vermelho d-flex float-left"
                                        small
                                    />
                                    <rkm-col class="mt-1 pt-0">
                                        vagas atingidas
                                    </rkm-col>

                                    <rkm-icon
                                        icon="exclamation-circle"
                                        class="leg-amarelo d-flex float-left"
                                        small
                                    />
                                    <rkm-col class="mt-1 pt-0">
                                        feriado/facultativo
                                    </rkm-col>
                                </rkm-row>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <Modal
            ref="Modal"
            :model="model"
            :habilita-agendamento-app="form.habilitaAgendamentoApp"
            @handleAlter="handleAlter"
        />

        <ModalPermissao
            ref="RkmModalPermissao"
            @saveModal="saveModal"
            :origem="origem"
        />

    </div>
</template>

<script>

// Mixins.
import { error, repository, stringCase, object, data, calculations, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Enuns.
import tipoJornada from '@/enums/exame-imagem/tipoJornada'
import modulo from '@/enums/cadastro/feriado/modulo'
import statusJornada from '@/enums/exame-imagem/statusJornada'

// Moment.
import moment from 'moment'

// Components.
import Modal from '@/components/exame-imagem/jornada/components/cadastro/Modal'
import ModalPermissao from '@/components/exame-imagem/jornada/components/cadastro/permissao/Modal'

export default {
    components: { Modal, ModalPermissao },
    computed:{
        grupoExames() {

            this.handlegrupoExame()

            return this.form.exames
        },
        prestadores() {

            this.handlePrestador()

            return this.form.prestadores
        },
        infraestruturas() {

            this.handleUnidade()

            if (this.jornada.unidadeId) {

                let infraestruturaPrincipal = this.form.unidadesParametrizadas.find(u => u.unidadeId === this.jornada.unidadeId).infraestruturas

                    this.getPrincipal(infraestruturaPrincipal)

                return infraestruturaPrincipal
            }

            return []
        },
        validations() {
            return {
                unidadeId: { required: true },
                infraestruturaId: { required: true },
                prestadorId: { required: true },
                exameId: { required: true },
                tipoId: { required: true },
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                diasSemana: { required: true },
                statusId: { required: true },
                tempoAtendimento: { required: true },
                horaInicial: {
                    required: true,
                    max_hour: this.jornada.primeiroHorario
                        ? this.formatTime(this.jornada.primeiroHorario)
                        : this.getMaxHour()
                },
                horaFim: {
                    required: true,
                    min_hour: this.jornada.ultimoHorario
                        ? this.formatTime(this.jornada.ultimoHorario)
                        : this.getMinHour()
                },
                vagas: { required: true, min_value: this.jornada.agendamentos ?? 1 },
            }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada'),
            feriado: this.getConectaSusRepository('cadastro.feriado.feriado'),
            controleJornada: this.getConectaSusRepository('exameImagem.parametrizacao'),
        }
    },
    data: () => ({
        origem: 'exame',
        isReadOnly: false,
        enums: {
            tipoJornada,
            modulo,
            statusJornada
        },
        dataAtual: '',
        tabIndex: 1,
        checkData: '',
        minDate: null,
        maxDate: null,
        desabilitaVolta: false,
        verificaDataAtual: false,
        autoriza: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handlegrupoExame() {

            const handlegrupoExame = this.form.exames

            if (handlegrupoExame && handlegrupoExame.length === 1) {

                this.jornada.exameId = handlegrupoExame[0].id
            }
        },
        handlePrestador() {

            const prestadores = this.form.prestadores

            if (prestadores && prestadores.length === 1) {

                this.jornada.prestadorId = prestadores[0].prestadorId
            }
        },
        handleUnidade() {

            const unidades = this.form.unidadesParametrizadas

            if (unidades && unidades.length === 1) {

                this.jornada.unidadeId = unidades[0].unidadeId
            }
        },
        getPrincipal(infraestruturaPrincipal) {

            let localAtendimento = infraestruturaPrincipal.find(u => u.principal === true)

            if(localAtendimento ){

                this.jornada.infraestruturaId = localAtendimento.id
            } else {

                this.jornada.infraestruturaId = null
            }
        },
        handleBlur(){

            const jornada = this.jornada
            const tempoAtendimento = this.jornada.tempoAtendimento
            const horaFim = this.jornada.horaFim
            const totalVagas = parseInt(jornada.vagas || 0) + parseInt(jornada.vagasApp || 0)

            jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
            jornada.horaFim = this.jornada.horaFim.substr(0, 5)

            if (this.jornada.tipoId == this.enums.tipoJornada.FIXA) {

                let inicioHoraHandle = jornada.horaInicial.split(':')
                let fimHoraHandle = jornada.horaFim.split(':')

                let inicioTratado = parseInt(inicioHoraHandle[0]* 60) + parseInt(inicioHoraHandle[1])
                let finalTratado = parseInt(fimHoraHandle[0]* 60) + parseInt(fimHoraHandle[1])

                let diferencaMinutos = finalTratado - inicioTratado

                if(jornada.vagas <= 0){

                    this.showValidationNotification("É necessário ter no mínimo uma vaga.")
                    this.jornada.vagas = ''
                    this.jornada.tempoAtendimento = ''
                    return
                }

                if(totalVagas && this.jornada.horaInicial && this.jornada.horaFim){

                    jornada.tempoAtendimento = Math.floor(diferencaMinutos / totalVagas)

                    if (tempoAtendimento !== jornada.tempoAtendimento) {
                        this.showAlert(`O tempo de atendimento foi alterado para ${jornada.tempoAtendimento} minuto(s).`, 'Atenção')
                    }
                }
            } else {

                jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
                jornada.tempoAtendimento = this.jornada.tempoAtendimento

                let totalMinutos = jornada.tempoAtendimento * totalVagas

                if(jornada.vagas <= 0){

                    this.showValidationNotification("É necessário ter no mínimo uma vaga.")
                    this.jornada.vagas = ''
                    this.jornada.tempoAtendimento = ''
                    return
                }

                if (this.jornada.tempoAtendimento) {

                    var horarioFinal = moment(jornada.horaInicial, "HH:mm")
                        .add(totalMinutos, 'minutes')
                        .format('HH:mm');

                    jornada.horaFim = horarioFinal

                    if (horaFim !== jornada.horaFim) {
                        this.showAlert(`O horário final foi alterado para ${jornada.horaFim}.`, 'Atenção')
                    }
                } else {

                    let inicioHoraHandle = jornada.horaInicial.split(':')
                    let fimHoraHandle = jornada.horaFim.split(':')

                    let inicioTratado = parseInt(inicioHoraHandle[0]* 60) + parseInt(inicioHoraHandle[1])
                    let finalTratado = parseInt(fimHoraHandle[0]* 60) + parseInt(fimHoraHandle[1])

                    let diferencaMinutos = finalTratado - inicioTratado

                    if(totalVagas && this.jornada.horaInicial && this.jornada.horaFim){

                        jornada.tempoAtendimento = Math.floor(diferencaMinutos / totalVagas)

                        if (tempoAtendimento !== jornada.tempoAtendimento) {
                            this.showAlert(`O tempo de atendimento foi alterado para ${jornada.tempoAtendimento} minuto(s).`, 'Atenção')
                        }
                    }
                }
            }
        },
        handleBlurHoraFim(){

            const jornada = this.jornada
            const tempoAtendimento = this.jornada.tempoAtendimento
            const totalVagas = parseInt(jornada.vagas || 0) + parseInt(jornada.vagasApp || 0)

            jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
            jornada.horaFim = this.jornada.horaFim.substr(0, 5)

            var inicioHoraHandle = jornada.horaInicial.split(':')
            var fimHoraHandle = jornada.horaFim.split(':')

            var inicioTratado = parseInt(inicioHoraHandle[0]* 60) + parseInt(inicioHoraHandle[1])
            var finalTratado = parseInt(fimHoraHandle[0]* 60) + parseInt(fimHoraHandle[1])

            var diferencaMinutos = finalTratado - inicioTratado

            if(totalVagas && this.jornada.horaInicial && this.jornada.horaFim){

                jornada.tempoAtendimento = Math.floor(diferencaMinutos / totalVagas)
            }

            if (tempoAtendimento !== jornada.tempoAtendimento) {
                this.showAlert(`O tempo de atendimento foi alterado para ${jornada.tempoAtendimento} minuto(s).`, 'Atenção')
            }
        },
        handleBlurTempoAtendimento(){

            const jornada = this.jornada
            const horaFim = this.jornada.horaFim
            const totalVagas = parseInt(jornada.vagas || 0) + parseInt(jornada.vagasApp || 0)

            jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
            jornada.tempoAtendimento = this.jornada.tempoAtendimento

            let totalMinutos = jornada.tempoAtendimento * totalVagas

            if(jornada.vagas <= 0){

                this.showValidationNotification("É necessário ter no mínimo uma vaga.")
                this.jornada.vagas = ''
                this.jornada.tempoAtendimento = ''
                return
            }

            if (this.jornada.tempoAtendimento) {

                var horarioFinal = moment(jornada.horaInicial, "HH:mm")
                    .add(totalMinutos, 'minutes')
                    .format('HH:mm');

                jornada.horaFim = horarioFinal
            }

            if (horaFim !== jornada.horaFim) {
                this.showAlert(`O horário final foi alterado para ${jornada.horaFim}.`, 'Atenção')
            }
        },
        add() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    var inicio = moment(this.jornada.periodo.start, 'YYYY/MM/DD');
                    var fim = moment(this.jornada.periodo.end, 'YYYY/MM/DD');

                    var diaInicio   = inicio.format('D');
                    var mesInicio = inicio.format('M');
                    var anoInicio  = inicio.format('YYYY');

                    var diaFim   = fim.format('D');
                    var mesFim = fim.format('M');
                    var anoFim  = fim.format('YYYY');

                    var dataInicio = new Date(anoInicio,mesInicio - 1,diaInicio);
                    var dataFinal = new Date(anoFim,mesFim -1 ,diaFim);

                    let msg = ''

                    var selecionaData = this.getFormatedDate(this.jornada.periodo.start, 'YYYY-MM-DD')
                    var dataAtual = this.model.dataAtual

                    if(selecionaData < dataAtual && this.autoriza == false){

                        this.verificaDataAtual = true

                    } else {

                        this.verificaDataAtual = false
                    }

                    if(this.verificaDataAtual == true){

                        const confirm = async () => {

                            this.$refs.RkmModalPermissao.open()

                            return false
                        }

                        const cancel = async () => {  }

                        const msg = `O período desta jornada possui uma ou mais data retroativa,
                            para continuar é necessário informar os dados do supervisor. Deseja continuar?`

                        this.showConfirmation(msg, confirm, cancel)
                        return false

                    } else {

                        for (var dataInserida = dataInicio; dataInserida <= dataFinal; dataInserida.setDate(dataInserida.getDate() + 1)){

                            const jornada = this.clone(this.jornada)

                            if (this.jornada.tipoId == this.enums.tipoJornada.DINAMICA) {

                                if(this.jornada.tempoAtendimento <= 0){

                                    this.showValidationNotification("O tempo de atendimento deve ter ao menos um minuto")

                                    this.jornada.tempoAtendimento = ''
                                    this.jornada.vagas = ''
                                    return
                                }
                            }

                            jornada.controleJornadaId = this.form.controleJornada

                            jornada.usuarioId = this.form.profissional.id

                            jornada.unidadeNome = this.form.unidadesParametrizadas
                                .find(u => u.unidadeId === this.jornada.unidadeId)
                                .nomeFantasia

                            jornada.prestadorId = this.jornada.prestadorId

                            if(this.jornada.prestadorId){

                                jornada.prestadorNome = jornada.unidadeNome
                            }

                            jornada.infraestruturaNome = this.infraestruturas
                                .find(i => i.id === this.jornada.infraestruturaId)
                                .nome

                            jornada.tipoNome = this.form.tipos
                                .find(t => t.id === this.jornada.tipoId)
                                .nome

                            jornada.exameNome = this.form.exames
                                .find(e => e.id === this.jornada.exameId)
                                .nome

                            jornada.statusNome = this.form.status
                                .find(s => s.id === this.jornada.statusId)
                                .nome

                            jornada.data = this.getFormatedDate(dataInserida, 'YYYY-MM-DD')

                            jornada.diasSemana.forEach((diaSemana) => {

                                var data = moment(jornada.data, 'YYYY-MM-DD').toDate()
                                var dia = data.getDay() + 1;

                                if (dia === diaSemana){

                                    jornada.semanaId = dia

                                    this.checkData = jornada.data

                                    let existeFeriado = false

                                    this.form.feriados.find((j) => {

                                        j.modulos.map(modulo => {

                                            if(modulo == this.enums.modulo.EXAME_IMAGEM) {

                                                if(j.data == this.getFormatedDate(jornada.data, 'DD/MM/YYYY')){

                                                    existeFeriado = true

                                                    const verificaFeriado = [j.data]

                                                    for( let i = 0; i < verificaFeriado.length; i++) {

                                                        msg = msg.concat('<br/> - ', verificaFeriado[i], ' - Feriado e/ou ponto facultativo.')
                                                    }
                                                }
                                            }
                                        })
                                    })

                                    if(!existeFeriado){

                                        const getDate = (data, hora) => moment(`${data} ${hora}`, 'YYYY-MM-DD HH:mm')

                                        jornada.horaInicial = jornada.horaInicial.substr(0, 5)
                                        jornada.horaFim = jornada.horaFim.substr(0, 5)

                                        const periodoInicial = getDate(jornada.data, this.jornada.horaInicial)
                                        const periodoFinal = getDate(jornada.data, this.jornada.horaFim)

                                        const existeJornada = this.model.jornadas.find(jornada => {

                                            const currentPeriodoInicial = getDate(jornada.data, jornada.horaInicial)
                                            const currentPeriodoFinal = getDate(jornada.data, jornada.horaFim)

                                            return jornada.jornadaId !== this.jornada.jornadaId && (
                                                (periodoInicial >= currentPeriodoInicial && periodoInicial <= currentPeriodoFinal)
                                                || (periodoFinal >= currentPeriodoInicial && periodoFinal <= currentPeriodoFinal)
                                                || (periodoInicial < currentPeriodoInicial && periodoFinal > currentPeriodoFinal)
                                            )
                                        })

                                        const formataData = this.getFormatedDate(jornada.data, 'DD/MM/YYYY')

                                        const verificaData = [formataData]

                                        if(existeJornada){

                                            for(let i = 0; i < verificaData.length; i++) {

                                                msg = msg.concat('<br/> - ', verificaData[i], ' - Conflito de horário.')
                                            }

                                            this.mensagemConflito(msg)
                                        }
                                        else {

                                            this.diasCalendario.push(
                                                {
                                                    'dates': data,
                                                    'title': 'icon-search',
                                                    'highlight': 'green'
                                                }
                                            )

                                            if (jornada.jornadaId == null) {
                                                
                                                jornada.jornadaId = this.uniqueId('jornada' + new Date().getTime())
                                                this.model.jornadas.push(jornada)
                                                jornada.agendamentos = 0
                                                jornada.vagasDisponiveis = parseInt(jornada.vagas || 0) + parseInt(jornada.vagasApp || 0)
                                                jornada.novaJornada = true
                                            }
                                            else {
                                               
                                                jornada.editJornada = true
                                                jornada.vagasDisponiveis = (parseInt(jornada.vagas || 0) + parseInt(jornada.vagasApp || 0)) - jornada.agendamentos

                                                this.$set(
                                                    this.model.jornadas,
                                                    this.model.jornadas.findIndex(j => j.jornadaId === jornada.jornadaId),
                                                    this.clone(jornada)
                                                )

                                                this.$set(
                                                    this.model.jornadasNotSave,
                                                    this.model.jornadasNotSave.findIndex(j => j.jornadaId === jornada.jornadaId),
                                                    this.clone(jornada)
                                                )
                                            }

                                            this.sucessAdd()
                                            this.$nextTick(() =>  this.mensagemConflito(msg))
                                            this.cancelForm()
                                        }
                                    } else {

                                        this.mensagemConflito(msg)
                                    }
                                }
                            })
                        }
                    }

                    this.$refs.Form.resetValidator()
                })
        },
        modalCalendario(item){

            const diaTratado = moment(item.date).format('YYYY-MM-DD')

            var data = moment(item.date, 'YYYY-MM-DD').toDate()
            var semanaId = data.getDay() + 1;

            const diaSelecionado = this.model.jornadas.find(
                dias => dias.data == diaTratado
            )

            if(diaSelecionado){

                const diaSelecionadoModal = this.model.jornadas.filter(p => p.data == diaTratado)
                this.$refs.Modal.open(item, diaSelecionadoModal, diaTratado, semanaId)
            }
        },
        mensagemConflito(msg){

            if(msg){

                this.showAlert('Não foi possível cadastrar a jornada nas seguintes datas: '  + msg)
            }
        },
        cancelForm(){

            const jornada = this.clone(this.jornada)

            if(jornada.jornadaId == null){

                this.$emit('backTabs')
                this.disabledSemanas()

            } else {

                if(this.jornada.tipoId == this.enums.tipoJornada.FIXA){

                    let horaInicial =  this.jornada.horaInicial
                    let horaFinal = this.jornada.horaFim
                    let vagas = this.jornada.vagas

                    if(horaFinal == null || horaInicial == null || vagas == null || vagas == ''){

                        this.showValidationNotification('É necessário incluir todos os campos obrigatórios.')

                        this.disabledVoltar()

                        return false
                    }

                    this.$emit('backTabs')

                } else {

                    if(this.jornada.tempoAtendimento == ''){

                        this.showValidationNotification('É necessário incluir todos os campos obrigatórios.')

                        this.disabledVoltar()

                        return false
                    }

                    this.$emit('backTabs')
                }
            }
        },
        disabledVoltar(){

            this.desabilitaVolta = true
        },
        resetJornada(){

            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''
            this.jornada.vagas = ''
            this.jornada.vagasApp = ''
            this.jornada.tempoAtendimento = ''
            this.jornada.periodo.start = ''
            this.jornada.periodo.end = ''
        },
        sucessAdd(){

            this.$emit('backTabsNotification')
        },
        validate() {

            return this.$refs.Form.validate()
        },
        disabledSemanas(){

            this.form.diasSemana.forEach(s => s.disabled = true)
        },
        saveModal(supervisorId){

            this.jornada.supervisorId = supervisorId
            this.autoriza = true
            this.add()
        },
        handleAlter(item) {
            this.$emit('handleAlter', item)
        },
        getMaxHour() {

            const horario = this.jornada.horaFim

            if (horario) {

                return moment(horario, 'HH:mm').subtract(1, 'minutes').format('HH:mm')
            }

            return false
        },
        getMinHour() {

            const horario = this.jornada.horaInicial

            if (horario) {

                return moment(horario, 'HH:mm').add(1, 'minutes').format('HH:mm')
            }

            return false
        },
    },
    mounted(){

        this.$refs.Form.resetValidator()
    },
    mixins: [ error, repository, stringCase, object, data, calculations, formats],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        profissional: { type: Object, required: true},
        jornada: { type: Object, required: true },
        index: { type: Boolean, default: null},
        habilita: { type: Number, default: null },
        diasCalendario: {type: Array, required: true}
    },
    watch: {
        'model.jornadas': function () {

            const jornadasAgrupadas = this.model.jornadas.reduce((agrupammento, unidade) => {
                const dataFormatada = moment(unidade.data, 'YYYY-MM-DD').format('YYYY-MM-DD');

                if (!agrupammento[dataFormatada]) {
                    agrupammento[dataFormatada] = {
                        dates: moment(unidade.data, 'YYYY-MM-DD').toDate(),
                        agendamentos: 0,
                        vagas: 0,
                    };
                }

                agrupammento[dataFormatada].agendamentos += parseInt(unidade.agendamentos);
                agrupammento[dataFormatada].vagas += parseInt(unidade.vagas || 0) + parseInt(unidade.vagasApp || 0);

                return agrupammento;
            }, {});

            const diasCalendario = Object.values(jornadasAgrupadas).map(unidade => ({
                dates: unidade.dates,
                title: `${unidade.agendamentos}/${unidade.vagas}`,
                highlight: unidade.agendamentos >= unidade.vagas ? 'red' : 'green'
            }));

            this.form.feriados.map(feriado =>

                feriado.modulos.map(modulo => {

                    if(modulo == this.enums.modulo.EXAME_IMAGEM){

                        diasCalendario.push({
                            'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                            'highlight': 'yellow',
                            'title': feriado.tipoNome,
                            'popover':  feriado.observacao
                        })
                    }
                })
            )

            this.$emit('getDiasCalendario', diasCalendario)
        },
        'jornada.periodo': {
            deep: true,
            handler: function (periodo) {

                this.jornada.diasSemana = []
                this.disabledSemanas()

                const dataStartInt = moment(periodo.start).format('DD/MM/YYYY')
                const dataEndInt = moment(periodo.end).format('DD/MM/YYYY')

                if(this.index != null || dataStartInt == dataEndInt){

                    if(periodo.end){

                        var periodoInicial = moment(periodo.start, 'YYYY/MM/DD');
                        var periodoFinal = moment(periodo.end, 'YYYY/MM/DD');

                        var diaInicial   = periodoInicial.format('D');
                        var mesInicial = periodoInicial.format('M');
                        var anoInicial  = periodoInicial.format('YYYY');

                        var diaFinal   = periodoFinal.format('D');
                        var mesFinal = periodoFinal.format('M');
                        var anoFinal  = periodoFinal.format('YYYY');

                        var dataInicial = new Date(anoInicial,mesInicial - 1,diaInicial);
                        var dataFim = new Date(anoFinal,mesFinal -1 ,diaFinal);

                        for (var dataInserida = dataInicial; dataInserida <= dataFim; dataInserida.setDate(dataInserida.getDate() + 1)) {

                            var data = moment(dataInserida, 'YYYY-MM-DD').toDate()

                            var dia = data.getDay() + 1;

                            if(!this.jornada.diasSemana.find(d => d == dia)){

                                this.jornada.diasSemana.push(dia)
                            }
                        }

                    } else {

                        if(periodo.start){

                            var dataStart = moment(periodo.start, 'YYYY-MM-DD').toDate()

                            var diaStart = dataStart.getDay() + 1;

                            if(!this.jornada.diasSemana.find(d => d == diaStart)){

                                this.jornada.diasSemana.push(diaStart)
                            }
                        }
                    }
                }

                if(periodo.start || periodo.end){

                    let indices = []

                    if(periodo.start){

                        let dataStart = moment(periodo.start, 'YYYY-MM-DD').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataStart.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.end){

                        let dataEnd = moment(periodo.end, 'YYYY-MM-DD').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataEnd.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.start && periodo.end){

                        indices = []

                        let dataStart = moment(periodo.start, 'YYYY-MM-DD')
                        let dataEnd = moment(periodo.end, 'YYYY-MM-DD')

                        let indice = 0

                        while (dataStart.isSameOrBefore(dataEnd) && indice < 7) {

                            const index = this.form.diasSemana.findIndex(d => d.id == dataStart.toDate().getDay() + 1)
                            indices.push(index)

                            dataStart.add(1, 'd')

                            indice++
                        }
                    }

                    indices.forEach(indice => {

                        this.form.diasSemana[indice].disabled = false
                    })
                }
            }
        },
    }
}
</script>

<style scoped>
.calendario {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.calendario img {
    max-width: 100%;
    max-height: 100%;
    margin: 1rem 0;
}
.form-group-radio-button-disabled, .form-group-checkbox-button-disabled {
    width: 100%
}
.leg-verde {
    color: #38a169;
    margin-top: 10px;
}
.leg-azul {
    color: #3182ce;
    margin-top: 10px;
}
.leg-vermelho {
    color: #e53e3e;
    margin-top: 10px;
}
.leg-amarelo {
    color: #d69e2e;
    margin-top: 10px;
}
</style>